<template>
    <div class="container" style="float: none;">
        <loader v-if="mediaLoading"/>
        <div>
            <div v-for="mediaType in docMediaTypes" class="form-group" :key="mediaType.mediaTypeId">
                <label class="col-md-2 control-label text-label">{{mediaType.name}}</label>
                <div class="col-md-10">
                    <table v-show="mediaList.find(x=> {return x.mediaTypeId === mediaType.mediaTypeId})" class="table">
                        <thead>
                            <tr>
                                <th style="width:10%">Download</th>
                                <th style="width:30%">File Name</th>
                                <th style="width:30%">Comment</th>
                                <th style="width:20%" v-show="!addOnly">Uploaded By</th>
                                <th style="width:10%">Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="mediaItem in mediaList.filter(m => {return m.mediaTypeId === mediaType.mediaTypeId})" :key="mediaItem.mediaId">
                                <td>
                                    <div style="text-align: center;">
                                        <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank" v-on:click="mediaDownloadRow(mediaItem.mediaId, mediaItem.mediaTypeId, mediaType.mediaSubtype, mediaItem.parentId, mediaItem.filename)"></a>
                                    </div>
                                </td>
                                <td>{{mediaItem.filename}}</td>
                                <td>{{mediaItem.comment}}</td>
                                <td v-show="!addOnly">{{mediaItem.createdBy}}</td>
                                <td>
                                    <div style="text-align: center;" v-if="!formDisabled">
                                        <a class="fa fa-ban" style="font-size: 18px;" target="_blank" v-on:click="mediaRemove(mediaItem.mediaId)"></a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-show="!(mediaList.find(x=> {return x.mediaTypeId === mediaType.mediaTypeId}))">
                        <label>No matching records</label>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label class="col-md-2">Add File</label>
                <div class="col-md-10">
                    <fieldset :disabled="formDisabled">
                        <form v-on:submit.prevent class="form" id="mediaForm" data-vv-scope="mediaFile">
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.mediaType') }">
                                        <label>Type</label>
                                        <select name="mediaType" class="form-control" v-model="mediaTypeId" v-validate="'required'" data-vv-validate-on="none">
                                            <option disabled value=''>Select a value</option>
                                            <option v-for="mediaType in docMediaTypes" v-bind:value="mediaType.mediaTypeId" :key="mediaType.mediaTypeId">
                                                {{mediaType.name}}
                                            </option>
                                        </select>
                                        <div><span v-show="errors.has('mediaFile.mediaType')" class="has-error">File type is required</span></div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.newFile') }">
                                        <label>File</label><br>
                                        <input name="newFile" ref="newFile" class="file" type="file" v-validate="'required'" data-vv-validate-on="none">
                                        <div><span v-show="errors.has('mediaFile.newFile')" class="has-error">File is required</span></div>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <label>Comment</label>
                                        <input type="text" class="form-control" v-model="comment">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-3"></div>
                                <div class="col-md-8">
                                    <div v-show="errors.any('mediaFile')">
                                        <span class="has-error">Validation issues must be corrected prior to upload</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-3"></div>
                                <div class="col-md-8">
                                    <div v-show="serverErrorList.length > 0">
                                        <span class="has-error">Validation issues must be corrected prior to submit</span>
                                        <ul class="has-error">
                                            <li v-for="serverError in serverErrorList" :key="serverError">{{ serverError }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <button class="btn btn-primary col-md-2" v-on:click="addFile">{{ addOnly ? "Add" : "Upload" }}</button>
                        </form>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mediaService from '../services/mediaService'
import loggingService from '../services/util/loggingService'
import loader from '../components/Loader.vue'

export default {
    name: 'e106ComplianceDocuments',
    components: {
        loader
    },
    data: function () {
        return {
            isDebug: false,
            mediaLoading: false,
            serverErrorList: [],
            docMediaTypes: [
                {name: 'Shape Files', mediaTypeId: mediaService.mediaType.E106ComplianceShapeFile},
                {name: 'Images', mediaTypeId: mediaService.mediaType.E106ComplianceImage},
                {name: 'Supporting Documents', mediaTypeId: mediaService.mediaType.E106SupportingDocuments},
                {name: 'Topographic Map', mediaTypeId: mediaService.mediaType.E106TopograpicMap}
            ],
            imageSubtypes: [],
            mediaList: [],
            comment: '',
            mediaTypeId: '',
            mediaSubtypeId: '',
            filename: ''
        }
    },
    props: {
        parentId: {},
        formDisabled: { default: false },
        loadOnMount: { default: true },
        addOnly: { default: false }
    },
    mounted () {
        if (this.loadOnMount) this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Site Form Documents', message)
        },
        loadMedia (mediaTypeId, mediaSubtypeId, parentId) {
            this.log('looking for parent: ' + parentId)
            return mediaService.list(this.$http, mediaTypeId, mediaSubtypeId, parentId).then(result => {
                this.mediaList = this.mediaList.concat(result.data)
                return result
            })
        },
        //does nothing until there are image subtypes
        loadImages () {
            var promises = []
            this.imageSubtypes.forEach(imageSubtype => {
                promises.push(this.loadMedia(mediaService.mediaType.E106ComplianceImage, imageSubtype.mediaSubtypeId, this.parentId))
            })
            return Promise.all(promises).then(result => { return result })
        },
        loadData () {
            this.mediaLoading = true
            var promises = [this.loadImages()]
            this.mediaList = []
            this.docMediaTypes.forEach(mediaType => {
                promises.push(this.loadMedia(mediaType.mediaTypeId, null, this.parentId))
            })
            Promise.all(promises).then(result2 => {
                this.log('After load, media list count: ' + this.mediaList.length)
                this.mediaLoading = false
            })
        },
        addFile () {
            this.$validator.validateAll('mediaFile').then(result => {
                this.log(`Validiting and Submitting File.`)
                if (result) {
                    var file = this.$refs['newFile'].files[0]
                    this.log(`Adding file. Type: ${this.mediaTypeId} Comment: ${this.comment} Name: ${file.name}`)
                    if (!this.addOnly) {
                        mediaService.putFile(this.$http, this.mediaTypeId, this.mediaSubtypeId, this.parentId, file, this.comment).then(result => {
                            //clean form
                            this.clearFileInput()
                            this.loadData()
                            this.errors.clear('mediaFile')
                        })
                    } else {
                        var mediaDto = {
                            mediaId: Date.now(),
                            mediaTypeId: this.mediaTypeId,
                            mediaSubtypeId: this.mediaSubtypeId,
                            comment: this.comment,
                            file: file,
                            filename: file.name
                        }
                        this.mediaList.push(mediaDto)
                        //clean form
                        this.clearFileInput()
                        this.errors.clear('mediaFile')
                    }
                } else {
                    this.log('Submit File - Invalid Form')
                }
            })
        },
        clearFileInput () {
            document.forms['mediaForm'].reset()
            this.mediaTypeId = ''
            this.mediaSubtypeId = ''
            this.comment = ''
        },
        mediaDownloadRow (mediaId) {
            var mediaItem = this.mediaList.find(x => { return x.mediaId === mediaId })
            this.log(`mediaDownloadRow - mediaId: ${mediaItem.mediaId} , mediaTypeId: ${mediaItem.mediaTypeId}, parentId: ${mediaItem.parentId}`)
            if (!this.addOnly) {
                mediaService.get(this.$http, mediaItem.mediaId, mediaItem.mediaTypeId, mediaItem.mediaSubtypeId, mediaItem.parentId).then(function (response) {
                    mediaService.saveFileToDownload(response, mediaItem.filename)
                })
            } else {
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(mediaItem.file)
                link.download = mediaItem.file.name
                link.click()
            }
        },
        mediaRemove (mediaId) {
            if (confirm('Are you sure you want to remove this file/document?')) {
                if (!this.addOnly) {
                    mediaService.removeByMediaId(this.$http, mediaId).then(result => {
                        this.loadData()
                    })
                } else {
                    this.mediaList = this.mediaList.filter(m => m.mediaId !== mediaId)
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// e106ComplianceDocuments.vue?ac5dd84c